import { FC, ReactElement } from 'react';
import { Grid } from 'react-styled-flexboxgrid';
import { useMedia } from 'react-use';

import { media } from '@savgroup-front-common/constants';

import { useLayout } from '../NewLayout.hooks';

import { $Content, $ContentWrapper } from './BanneredLayout.styles';

const Content: FC<{
  children?: ReactElement | ReactElement[];
}> = ({ children }) => {
  const isGridFluidActive = useMedia(media.maxWidth.md);
  const { enableServicePortal } = useLayout();

  return (
    <$ContentWrapper>
      <Grid fluid={isGridFluidActive}>
        <$Content $enableServicePortal={enableServicePortal}>
          {children}
        </$Content>
      </Grid>
    </$ContentWrapper>
  );
};

Content.displayName = 'Content';
export default Content;
